import {Action} from '@ngrx/store';
import {BulletinBoardPost} from '@app/core/models/bulletinBoardPost.model';
import {Group} from '@app/core/models/group.model';
import {BulletinBoardPostComment} from '@app/core/models/bulletinBoardPostComment.model';
import {IMessageBoardPostDataJson} from '@app/modules/home/modules/bulletin-board/components/create-edit-bulletin-post/create-edit-bulletin-post.component';
import {Pagination} from '@app/core/models/pagination.model';
import {BulletinBoardPostLike} from '@app/core/models/bulletinBoardPostLike.model';
import {User} from '@app/core/models/user.model';

export enum EBulletinBoardActions {
	GetBulletinPosts = '[BulletinBoard] Get Bulletin Posts',
	GetBulletinPostsSuccess = '[BulletinBoard] Get Bulletin Posts Success',
	GetBulletinPost = '[BulletinBoard] Get Bulletin Post',
	GetBulletinPostSuccess = '[BulletinBoard] Get Bulletin Post Success',
	PostBulletinPost = '[BulletinBoard] Post Bulletin Post',
	PostBulletinPostSuccess = '[BulletinBoard] Post Bulletin Post Success',
	PatchBulletinPost = '[BulletinBoard] Patch Bulletin Post',
	PatchBulletinPostSuccess = '[BulletinBoard] Patch Bulletin Post Success',
	ClearEditPostComponent = '[BulletinBoard] Clear Edit Post Component',
	GetGroupsForBulletinPosts = '[BulletinBoard] Get Groups For Bulletin Posts',
	GetGroupsForBulletinPostsSuccess = '[BulletinBoard] Get Groups For Bulletin Posts Success',
	GetBulletinPostComments = '[BulletinBoard] Get Bulletin Post Comments',
	GetBulletinBoardCommentsSuccess = '[BulletinBoard] Get Bulletin Post Comments Success',
	CreateBulletinBoardComment = '[BulletinBoard] Create Bulletin Comment',
	CreateBulletinBoardCommentSuccess = '[BulletinBoard] Create Bulletin Comment Success',
	PatchBulletinBoardComment = '[BulletinBoard] Patch Bulletin Comment',
	PatchBulletinBoardCommentSuccess = '[BulletinBoard] Patch Bulletin Comment Success',
	DeleteBulletinBoardComment = '[BulletinBoard] Delete Bulletin Comment',
	DeleteBulletinBoardCommentSuccess = '[BulletinBoard] Delete Bulletin Comment Success',
	DeleteBulletinPost = '[BulletinBoard] Delete Bulletin Post',
	DeleteBulletinPostSuccess = '[BulletinBoard] Delete Bulletin Post Success',
	GetBulletinPostCommentsSuccess = '[BulletinBoard] Get Bulletin Post Comments Success',
	SetSelectedPostForComments = '[BulletinBoard] Set Selected Post For Comments',
	ClearBulletinPosts = '[BulletinBoard] Clear Bulletin Posts',
	LikePost = '[BulletinBoard] Like Post',
	LikePostSuccess = '[BulletinBoard] Like Post Success',
	DislikePost = '[BulletinBoard] Unlike Post',
	DislikePostSuccess = '[BulletinBoard] Unlike Post Success',
	GetPostSeenByInfo = '[BulletinBoard] Get Post Seen By Info',
	GetPostSeenByInfoSuccess = '[BulletinBoard] Get Post Seen By Info Success',
	GetPostLikedByInfo = '[BulletinBoard] Get Post Liked By Info',
	GetPostLikedByInfoSuccess = '[BulletinBoard] Get Post Liked By Info Success',

	GetPunchBulletinBoardPosts = '[BulletinBoard] Get Punch Bulletin Board Posts',
	GetPunchBulletinBoardPostsSuccess = '[BulletinBoard] Get Punch Bulletin Board Posts Success',
	GetPunchBulletinBoardPostComments = '[BulletinBoard] Get Punch Bulletin Board Post Comments',
	GetPunchBulletinBoardPostCommentsSuccess = '[BulletinBoard] Get Punch Bulletin Board Post Comments Success',
	GetPunchBulletinBoardPostInfoSeenBy = '[BulletinBoard] Get Punch Bulletin Board Post Seen By',
	GetPunchBulletinBoardPostInfoSeenBySuccess = '[BulletinBoard] Get Punch Bulletin Board Post Seen By Success',
	GetPunchBulletinBoardPostInfoLikedBy = '[BulletinBoard] Get Punch Bulletin Board Post Liked By',
	GetPunchBulletinBoardPostInfoLikedBySuccess = '[BulletinBoard] Get Punch Bulletin Board Post Liked By Success',

	ClearLikes = '[BulletinBoard] ClearLikes',
}

export class GetBulletinPosts implements Action {
	public readonly type = EBulletinBoardActions.GetBulletinPosts;

	constructor(public page_size: number = 50, public page: number = 1, public departmentId: number = undefined) {
	}
}

export class GetBulletinPostsSuccess implements Action {
	public readonly type = EBulletinBoardActions.GetBulletinPostsSuccess;

	constructor(public bulletinPosts: BulletinBoardPost[], public pagination: Pagination) {
	}
}

export class GetGroupsForBulletinPosts implements Action {
	public readonly type = EBulletinBoardActions.GetGroupsForBulletinPosts;

	constructor() {
	}
}

export class GetGroupsForBulletinPostsSuccess implements Action {
	public readonly type = EBulletinBoardActions.GetGroupsForBulletinPostsSuccess;

	constructor(public groups: Group[]) {
	}
}

export class GetBulletinPost implements Action {
	public readonly type = EBulletinBoardActions.GetBulletinPost;

	constructor(public id: number) {
	}
}

export class GetBulletinPostSuccess implements Action {
	public readonly type = EBulletinBoardActions.GetBulletinPostSuccess;

	constructor(public bulletinPost: BulletinBoardPost) {
	}
}

export class PostBulletinPost implements Action {
	public readonly type = EBulletinBoardActions.PostBulletinPost;

	constructor(public post: IMessageBoardPostDataJson) {
	}
}

export class PostBulletinPostSuccess implements Action {
	public readonly type = EBulletinBoardActions.PostBulletinPostSuccess;

	constructor(public post: BulletinBoardPost) {
	}
}

export class PatchBulletinPost implements Action {
	public readonly type = EBulletinBoardActions.PatchBulletinPost;

	constructor(
		public id: number,
		public post: IMessageBoardPostDataJson,
	) {
	}
}

export class PatchBulletinPostSuccess implements Action {
	public readonly type = EBulletinBoardActions.PatchBulletinPostSuccess;

	constructor(public post: BulletinBoardPost) {
	}
}

export class GetBulletinPostComments implements Action {
	public readonly type = EBulletinBoardActions.GetBulletinPostComments;

	constructor(
		public page_size: number,
		public page: number,
		public postId: number,
	) {
	}
}

export class GetBulletinPostCommentsSuccess implements Action {
	public readonly type = EBulletinBoardActions.GetBulletinPostCommentsSuccess;

	constructor(public comments: BulletinBoardPostComment[], public  postId: number, public pagination: Pagination) {
	}
}

export class CreateBulletinBoardComment implements Action {
	public readonly type = EBulletinBoardActions.CreateBulletinBoardComment;

	constructor(
		public boardPost: BulletinBoardPost,
		public comment: string,
	) {
	}
}

export class CreateBulletinBoardCommentSuccess implements Action {
	public readonly type = EBulletinBoardActions.CreateBulletinBoardCommentSuccess;

	constructor(public comment: BulletinBoardPostComment, public boardPost: BulletinBoardPost) {
	}
}

export class PatchBulletinBoardComment implements Action {
	public readonly type = EBulletinBoardActions.PatchBulletinBoardComment;

	constructor(
		public postId: number,
		public commentId: number,
		public comment: string,
	) {
	}
}

export class PatchBulletinBoardCommentSuccess implements Action {
	public readonly type = EBulletinBoardActions.PatchBulletinBoardCommentSuccess;

	constructor(
		public comment: BulletinBoardPostComment,
		public postId: number,
		public commentId: number,
	) {
	}
}

export class DeleteBulletinBoardComment implements Action {
	public readonly type = EBulletinBoardActions.DeleteBulletinBoardComment;

	constructor(
		public postId: number,
		public commentId: number,
	) {
	}
}

export class DeleteBulletinBoardCommentSuccess implements Action {
	public readonly type = EBulletinBoardActions.DeleteBulletinBoardCommentSuccess;

	constructor(public comment: BulletinBoardPostComment, public postId) {
	}
}

export class DeleteBulletinPost implements Action {
	public readonly type = EBulletinBoardActions.DeleteBulletinPost;

	constructor(public postId: number) {
	}
}

export class DeleteBulletinPostSuccess implements Action {
	public readonly type = EBulletinBoardActions.DeleteBulletinPostSuccess;

	constructor(public postId: number) {
	}
}

export class ClearEditPostComponent implements Action {
	public readonly type = EBulletinBoardActions.ClearEditPostComponent;

	constructor() {
	}
}

export class SetSelectedPostForComments implements Action {
	public readonly type = EBulletinBoardActions.SetSelectedPostForComments;

	constructor(public postId: number) {
	}
}

export class LikePost implements Action {
	public readonly type = EBulletinBoardActions.LikePost;

	constructor(public bulletinBoardPost: BulletinBoardPost) {
	}
}

export class LikePostSuccess implements Action {
	public readonly type = EBulletinBoardActions.LikePostSuccess;

	constructor(public like: BulletinBoardPostLike, public bulletinBoardPost: BulletinBoardPost) {
	}
}

export class DislikePost implements Action {
	public readonly type = EBulletinBoardActions.DislikePost;

	constructor(public bulletinBoardPost: BulletinBoardPost) {
	}
}

export class DislikePostSuccess implements Action {
	public readonly type = EBulletinBoardActions.DislikePostSuccess;

	constructor(public like: BulletinBoardPostLike, public  bulletinBoardPost: BulletinBoardPost) {
	}
}

export class GetPostSeenByInfo implements Action {
	public readonly type = EBulletinBoardActions.GetPostSeenByInfo;

	constructor(public bulletinBoardPost: BulletinBoardPost) {
	}
}

export class GetPostSeenByInfoSuccess implements Action {
	public readonly type = EBulletinBoardActions.GetPostSeenByInfoSuccess;

	constructor(public users: User[]) {
	}
}

export class GetPostLikedByInfo implements Action {
	public readonly type = EBulletinBoardActions.GetPostLikedByInfo;

	constructor(public bulletinBoardPost: BulletinBoardPost, public page: number, public pageSize: number) {
	}
}

export class GetPostLikedByInfoSuccess implements Action {
	public readonly type = EBulletinBoardActions.GetPostLikedByInfoSuccess;

	constructor(public likes: BulletinBoardPostLike[], public pagination: Pagination) {
	}
}

export class GetPunchBulletinBoardPosts implements Action {
	public readonly type = EBulletinBoardActions.GetPunchBulletinBoardPosts;

	constructor(public page_size: number = 1, public page: number = 1, public departmentId: number = undefined) {
	}
}

export class ClearBulletinPosts implements Action {
	public readonly type = EBulletinBoardActions.ClearBulletinPosts;

	constructor() {
	}
}

export class GetPunchBulletinBoardPostComments implements Action {
	public readonly type = EBulletinBoardActions.GetPunchBulletinBoardPostComments;

	constructor(
		public page_size: number,
		public page: number,
		public postId: number,
	) {
	}
}

export class GetPunchBulletinBoardPostInfoLikedBy implements Action {
	public readonly type = EBulletinBoardActions.GetPunchBulletinBoardPostInfoLikedBy;

	constructor(public bulletinBoardPost: BulletinBoardPost) {
	}
}

export class GetPunchBulletinBoardPostInfoSeenBy implements Action {
	public readonly type = EBulletinBoardActions.GetPunchBulletinBoardPostInfoSeenBy;

	constructor(public bulletinBoardPost: BulletinBoardPost) {
	}
}

export class ClearLikes implements Action {
	public readonly type = EBulletinBoardActions.ClearLikes;

	constructor() {
	}
}

export type BulletinBoardActions =
	GetBulletinPosts |
	GetBulletinPostsSuccess |
	GetBulletinPost |
	GetBulletinPostSuccess |
	PostBulletinPost |
	PostBulletinPostSuccess |
	PatchBulletinPost |
	PatchBulletinPostSuccess |
	ClearEditPostComponent |
	GetGroupsForBulletinPosts |
	GetGroupsForBulletinPostsSuccess |
	GetBulletinPostComments |
	GetBulletinPostCommentsSuccess |
	CreateBulletinBoardComment |
	CreateBulletinBoardCommentSuccess |
	DeleteBulletinPost |
	DeleteBulletinPostSuccess |
	PatchBulletinBoardComment |
	PatchBulletinBoardCommentSuccess |
	SetSelectedPostForComments |
	DeleteBulletinBoardCommentSuccess |
	LikePost |
	LikePostSuccess |
	DislikePost |
	DislikePostSuccess |
	GetPostSeenByInfo |
	GetPostSeenByInfoSuccess |
	GetPostLikedByInfo |
	GetPostLikedByInfoSuccess |
	GetPunchBulletinBoardPosts |
	GetPunchBulletinBoardPostComments |
	GetPunchBulletinBoardPostInfoLikedBy |
	GetPunchBulletinBoardPostInfoSeenBy |
	ClearBulletinPosts |
	ClearLikes
	;
